import React from 'react';

const IconeLi = (props) => {
    return (
        <svg fill="" viewBox="0 0 12 12" height="1em" width="1em" {...props}>
          <path fill="currentColor" d="M6 11V4l4.5 3.5L6 11z" />
        </svg>
      );
}

export default IconeLi